import React from 'react';
import { Lightbulb, Compass, Cog, Sparkles } from 'lucide-react';

const CreativeProcess = () => {
  const processSteps = [
    {
      icon: Lightbulb,
      step: '01',
      title: 'Concept',
      description: 'Developing strong visual ideas aligned with brand strategy.'
    },
    {
      icon: Compass,
      step: '02',
      title: 'Direction',
      description: 'Guiding designers, photographers, and editors toward a cohesive creative vision.'
    },
    {
      icon: Cog,
      step: '03',
      title: 'Production',
      description: 'Managing the creative process to ensure projects are delivered efficiently and at a high standard.'
    },
    {
      icon: Sparkles,
      step: '04',
      title: 'Refinement',
      description: 'Polishing work to ensure clarity, impact, and brand consistency.'
    }
  ];

  return (
    <section className="py-24 px-6 bg-zinc-950 fade-in-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold mb-6">
            My Creative <span className="text-gold">Approach</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Strong creative work comes from combining vision with structure. My role is to 
            translate ideas into clear direction while building workflows that allow creative 
            teams to do their best work.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {processSteps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div 
                key={index}
                className="group relative text-center"
              >
                <div className="mb-6 inline-flex items-center justify-center w-20 h-20 border-2 border-gold group-hover:border-magenta transition-colors duration-300">
                  <Icon className="text-gold group-hover:text-magenta transition-colors duration-300" size={32} />
                </div>
                <div className="text-6xl font-playfair font-bold text-gray-800 mb-4">{step.step}</div>
                <h3 className="text-2xl font-bold mb-4">{step.title}</h3>
                <p className="text-gray-400 leading-relaxed">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CreativeProcess;